import { productCardType } from '@/commonTypes';
import React from 'react';
import styles from './styles.module.css';
import Gallery from '../Gallery';
import ProductInformation from '../ProductInformation';
import PurchaseCard from '../PurchaseCard';

export default function SingleproductHero({ product }: { product?: productCardType }) {
  return (
    <div className={`${styles.container}`}>
      <Gallery data={product} />
      {/* <div className={`${styles.container}`}> */}
      <ProductInformation product={product} />
      <PurchaseCard product={product} />
    </div>
    // </div>
  );
}
